import { useEffect } from "react";
import axios from "../../utills/api";

export default function SSOLogin() {

  useEffect(() => {

    const run = async () => {

      const params =
        new URLSearchParams(
          window.location.search
        );

      const token =
        params.get("token");

      if (!token) {
        window.location.href = "/login";
        return;
      }

      try {

        const res = await axios.get(
          "/sso/verify",
          {
            headers: {
              Authorization:
                `Bearer ${token}`,
            },
          }
        );

        localStorage.setItem(
          "token",
          token
        );

        localStorage.setItem(
          "user",
          JSON.stringify(
            res.data.user
          )
        );

        window.location.href =
          "/dashboard";

      } catch {

        window.location.href =
          "/login";
      }
    };

    run();

  }, []);

  return <div>Signing in...</div>;
}